let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cZdR1")).then(() => parcelRequire('4tMAO'));